import { useCallback, useEffect, useState } from "react";

export const useOssAsyncData = ({
  fetcher,
  fallbackData,
  errorMessage,
  deps,
  debounceMs = 0,
}) => {
  const [data, setData] = useState(fallbackData);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      setData((await fetcher()) || fallbackData);
    } catch (e) {
      setError(e.response?.data?.message || errorMessage);
      setData(fallbackData);
    } finally {
      setLoading(false);
    }
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!debounceMs) {
      load();
      return undefined;
    }

    const timer = setTimeout(load, debounceMs);
    return () => clearTimeout(timer);
  }, [load, debounceMs]);

  return { data, setData, loading, error, setError, load };
};

